import { Component, ViewChild, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { BaseGridComponent } from '@app/cp/shared/base-components/base-grid.component';
import { WidgetSearch } from '@app/cp/shared/models/WidgetSearch';
import * as _ from 'lodash';
import { DashboardService } from '@app/cp/shared/services/dashboard.service';
import { WindowContents } from '@app/cp/shared/enums/windowContents';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { DashboardWidgetService } from '@app/cp/shared/services/dashboardWidget.service';
import { v_QuoteBus } from '@app/cp/shared/models/v_QuoteBus';
import { v_QuoteGridBus } from '@app/cp/shared/models/v_QuoteGridBus';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { RowArgs, SelectionEvent } from '@progress/kendo-angular-grid';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';

@UseFeatureFlagSet()
@Component({
    selector: 'quotes-grid',
    templateUrl: './quotes-grid.component.html',
    styleUrls: ['./quotes-grid.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuotesGridComponent extends BaseGridComponent<v_QuoteBus, null>  {

    compFeatureFlagSet: IFeatureFlagSet = this as any;

    searchParam: WidgetSearch;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, private svc_data: DispatchesService, private svc_dashWidget: DashboardWidgetService, private svc_dashboard: DashboardService) {
        super(globals, featureFlagService);
        this.allData = this.allData.bind(this);
    }

    @Input() inputData: any;
    @Input() dataFilter: WidgetSearch;
    @Input() changeCheck: string;
    @Output() openRequest = new EventEmitter<any>();

    loaderState: boolean = true;
    quotes: v_QuoteGridBus;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public contentTypes = WindowContents;

    initialLoad: boolean = true;

    ngOnInit() {
        this.setup(this.dataFilter);
        this.initialLoad = false;
    }

    ngOnChanges() {
        this.loaderState = true;
        if (!this.initialLoad) {
            this.setup(this.dataFilter);
        }
    }
    public selectionKey(context: RowArgs): string {
        return context.dataItem.quoteId;
    }
    getData() {
        this.loaderState = true;
        this.hideError();
        this.svc_dashboard.getDashboardOpenQuotesGrid(this.searchParam).subscribe((data: BaseMessageInfo) => {
            if (data == null || data.primaryReturn == null) {
                this.handleNetworkError(null);
            } else {
                //this.quotes = data;
                this.data = data.primaryReturn;

                this.originalGridData = _.cloneDeep(this.data);
                this.gridData = orderBy(filterBy(this.originalGridData, this.filter), this.sort);

                this.loaderState = false;
                this.reloadIds()
            }
        },
            error => this.handleNetworkError(error));
    }

    returnError: boolean = false;

    handleNetworkError(error) {
        this.showError();
    }

    showError() {
        this.loaderState = false;
        this.returnError = true;
    }

    hideError() {
        this.returnError = false;
    }

    public setup(data: WidgetSearch) {
        this.searchParam = data;
        this.getData();
    }

    showDetailsPopup(id: string, type: number) {
        this.setReloadIds(id);
        this.svc_dashboard.openDQOIPopup(id, type);
    }

    @ViewChild(TooltipDirective) public tooltipDir: TooltipDirective;

    public showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === 'TD' || element.nodeName === 'TH')
            && element.offsetWidth < element.scrollWidth) {
            this.tooltipDir.toggle(element);
        } else {
            this.tooltipDir.hide();
        }
    }

    public openNewTab(linkObj: any) {
        window.open(linkObj.url, "_blank");
    }
}
